import {
  CUSTOMER_PLATFORM_URL,
  USER_PLATFORM_URL,
} from "shared/lib/constants/urls";
import { ENVIRONMENT } from "shared/lib/constants/environment";
import { ValueOfObjectFields } from "shared/lib/interfaces/utils";

type ENV_TYPE = ValueOfObjectFields<typeof ENVIRONMENT>;

const Router = {
  home: () => "/",
  individual: () => "/individual",
  business: () => "/business",
  about: () => "/about",
  callerSuccessStories: () => "/caller-success",
  customerSuccessStories: (storySlug?: string) =>
    `/customer-success${storySlug ? `/story/${storySlug}` : ""}`,
  pricing: () => "/pricing",
  privacyPolicy: () => "/privacy-policy",
  termsOfService: () => "/terms-of-service",
  masterServiceAgreement: () => "/legal/msa",
  glenXTermsOfService: () => "/legal/terms_of_service",
  notFound: () => "/404",
  blog: () => "/blog",
  post: (slug: string) => `/${slug}`,
  openings: () => "/openings/remote-sales-jobs",
  applicationStatusInReview: () => `/application-in-review`,
  // Applicant funnel v2 routes
  apply: () => "/apply",
  applyQualify: () => "/apply/qualify",
  applyOrientation: () => "/apply/orientation",
  applyForm: () => "/apply/form",
  applyInterview: () => "/apply/interview",
  userPortal: () =>
    USER_PLATFORM_URL[process.env.NEXT_PUBLIC_ENV as ENV_TYPE] ||
    USER_PLATFORM_URL[ENVIRONMENT.PRODUCTION],
  customerPortal: () =>
    CUSTOMER_PLATFORM_URL[process.env.NEXT_PUBLIC_ENV as ENV_TYPE] ||
    CUSTOMER_PLATFORM_URL[ENVIRONMENT.PRODUCTION],
  helpDocs: () => "https://help.glencoco.com/en/",
};

export default Router;
